export const PARTNERS_URL = `${BACKOFFICE_API_URL}/partners/partner`
export const PARTNER_DETAILS = `${BACKOFFICE_API_URL}/partners/partner/:id`
export const PARTNER_BANK_ACCOUNTS = `${BACKOFFICE_API_URL}/partners/partner/:partner_id/bank-details`
export const EDIT_CREATE_PARTNER_BANK_ACCOUNT = `${BACKOFFICE_API_URL}/partners/partner/bank-details/create`
export const UPDATE_PARTNER = `${PARTNERS_URL}/:partner_id`
